<div class="dialog-container">
  <!-- Header -->
  <div class="dialog-header">
    <h2 class="dialog-title">Tell us about your new job or internship</h2>
    <button class="close-btn" (click)="onClose()" aria-label="Close dialog">
      <i class="fa-light fa-xmark" aria-hidden="true"></i>
    </button>
  </div>

  <!-- Subtitle -->
  <p class="dialog-subtitle">
    Landing a job or internship is a big deal. Share it with us and we'll keep your profile and recommendations up to date.
  </p>

  <!-- Role Type Selection -->
  <div class="field-group">
    <p class="field-label">What type of role are you in?</p>
    <div class="role-cards">
      @for (card of roleCards; track card.type) {
        <button
          class="role-card"
          [class.role-card-selected]="selectedRole === card.type"
          (click)="selectRole(card.type)"
          [attr.aria-pressed]="selectedRole === card.type"
        >
          <div class="role-icon-wrapper">
            <i [class]="card.icon" aria-hidden="true"></i>
          </div>
          <p class="role-label">{{ card.label }}</p>
          <p class="role-description">{{ card.description }}</p>
        </button>
      }
    </div>
  </div>

  <!-- Organization -->
  <div class="field-group">
    <label class="field-label" for="organization-input">Where do you work?</label>
    <div class="org-input-wrapper">
      <input
        id="organization-input"
        type="text"
        class="org-input"
        [formControl]="organizationControl"
        [matAutocomplete]="orgAuto"
        placeholder=""
      />
    </div>
    <mat-autocomplete #orgAuto="matAutocomplete" panelClass="job-landing-autocomplete-panel">
      @for (org of filteredOrganizations | async; track org) {
        <mat-option [value]="org">{{ org }}</mat-option>
      }
    </mat-autocomplete>
  </div>

  <!-- Source -->
  <div class="field-group">
    <p class="field-label">
      <span>How'd you find this job or internship?</span>
      <span class="field-optional">&nbsp; (optional)</span>
    </p>
    <div class="source-options">
      <mat-radio-group [(ngModel)]="selectedSource" class="source-radio-group">
        @for (source of sourceOptions; track source) {
          <mat-radio-button [value]="source" color="primary">
            {{ source }}
            @if (source === 'Other') {
              <input
                type="text"
                class="other-source-input"
                [(ngModel)]="otherSourceText"
                [disabled]="selectedSource !== 'Other'"
                placeholder=""
              />
            }
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  </div>

  <!-- Submit -->
  <div class="dialog-actions">
    <button
      class="submit-btn"
      [disabled]="isSubmitDisabled"
      (click)="onSubmit()"
    >
      Submit
    </button>
  </div>
</div>
